<template>
  <div
    id="charts1"
    :style="{ width: '95%', height: '100%', margin: '0 auto' }"
  ></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    drawLine() {
      if (document.getElementById("charts1") == null) {
        return;
      }
      this.$echarts.dispose(document.getElementById("charts1"));
      let myChart = this.$echarts.init(document.getElementById("charts1"));
      myChart.setOption({}, true);
      let xLabel = ["1月", "2月", "3月", "4月", "5月", "6月"];
      let L0 = ["400", "600", "220", "850", "500", "400"];
      let L1 = ["500", "300", "720", "350", "800", "600"];
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          align: "left",
          right: "30px",
          type: "plain",
          top: "10px",
          textStyle: {
            color: "#7ec7ff",
            fontSize: 12,
          },
          itemGap: 25,
          itemWidth: 18,
        },
        grid: {
          top: "50px",
          left: "80px",
          right: "15px",
          bottom: "50px",
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              show: false,
            },
            axisLabel: {
              color: "#A1A7B3",
              padding: 10,
              fontSize: 12,
              formatter: function (data) {
                return data;
              },
            },
            axisTick: {
              show: false,
            },
            data: xLabel,
          },
        ],
        yAxis: [
          {
            name: "单位(kw·h)",
            nameTextStyle: {
              color: "#7ec7ff",
              fontSize: 12,
              padding: 10,
            },
            splitLine: {
              lineStyle: {
                color: "#A1A7B3",
                type: "dashed",
              },
            },
            axisLabel: {
              show: true,
              margin: 10,
              color: "#A1A7B3",
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "去年",
            type: "line",
            symbol: "circle", // 默认是空心圆（中间是白色的），改成实心圆
            showAllSymbol: true,
            symbolSize: 0,
            smooth: true,
            lineStyle: {
              width: 2,
              color: "rgba(84,131,255,1)", // 线条颜色
              borderColor: "rgba(0,0,0,.4)",
            },
            itemStyle: {
              color: "rgba(84,131,255,1)",
            },
            tooltip: {
              show: true,
            },
            areaStyle: {
              //区域填充样式
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(84,131,255,.3)",
                  },
                  {
                    offset: 1,
                    color: "rgba(84,131,255, 0)",
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
              shadowColor: "rgba(25,163,223, 0.5)", //阴影颜色
              shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
            },
            data: L0,
          },
          {
            name: "今年",
            type: "line",
            symbol: "circle", // 默认是空心圆（中间是白色的），改成实心圆
            showAllSymbol: true,
            symbolSize: 0,
            smooth: true,
            lineStyle: {
              width: 2,
              color: "rgba(77,192,36,1)", // 线条颜色
            },
            itemStyle: {
              color: "rgba(77,192,36,1)",
            },
            tooltip: {
              show: true,
            },
            areaStyle: {
              //区域填充样式
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(77,192,36,.3)",
                  },
                  {
                    offset: 1,
                    color: "rgba(77,192,36, 0)",
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
              shadowColor: "rgba(10,219,250, 0.5)", //阴影颜色
              shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
            },
            data: L1,
          },
        ],
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 20);
    },
  },
  mounted() {
    this.drawLine();
  },
};
</script>

<style>
</style>